import {
  EditAmountResult,
  EditAmountServiceSnapshot,
  EditAmountTicketSnapshot
} from '../model/edit-amount.model';
import { sameServiceId } from './service-table.utils';

function applyServiceSnapshot(
  target: Record<string, any>,
  patch: EditAmountServiceSnapshot
): void {
  if (patch.total != null) {
    target['total'] = patch.total;
  }
  if (patch.moneda != null) {
    target['moneda'] = patch.moneda;
  }
  if (patch.editOperation != null) {
    target['editOperation'] = patch.editOperation;
  }
  if (patch.newTotalCostoSoles != null) {
    target['newTotalCostoSoles'] = patch.newTotalCostoSoles;
  }
  if (patch.newTotalCostoDolares != null) {
    target['newTotalCostoDolares'] = patch.newTotalCostoDolares;
  }
  // Monto editado → costo unitario ya no aplica (paridad Core).
  target['costoUnitario'] = null;
}

function applyTicketSnapshot(
  target: Record<string, any>,
  patch: EditAmountTicketSnapshot
): void {
  if (patch.total != null) {
    target['total'] = patch.total;
    target['monto'] = patch.total;
  }
  if (patch.moneda != null) {
    target['moneda'] = patch.moneda;
  }
  if (patch.editOperation != null) {
    target['editOperation'] = patch.editOperation;
  }
  if (patch.newTotalCostoSoles != null) {
    target['newTotalCostoSoles'] = patch.newTotalCostoSoles;
  }
  if (patch.newTotalCostoDolares != null) {
    target['newTotalCostoDolares'] = patch.newTotalCostoDolares;
  }
}

/** Patch lista de servicios de programación / mass OS / aventura. */
export function applyEditAmountResultToServices(
  services: any[] | null | undefined,
  result: EditAmountResult | null | undefined,
  idKey: string = 'id'
): void {
  if (!Array.isArray(services) || !result?.ok) {
    return;
  }

  const snapshots = result.services ?? [];
  for (const snapshot of snapshots) {
    if (!snapshot?.id) continue;
    const row = services.find((service) =>
      sameServiceId(service, snapshot.id, idKey)
    );
    if (row) {
      applyServiceSnapshot(row, snapshot);
    }
  }
}

/** Patch ticket + servicio padre (Ticketería expand). */
export function applyEditAmountResultToTicketContext(options: {
  tickets?: any[] | null;
  ticketRow?: any | null;
  serviceRow?: any | null;
  result: EditAmountResult | null | undefined;
}): void {
  const { result } = options;
  if (!result?.ok) {
    return;
  }

  if (result.ticket?.id) {
    if (options.ticketRow && String(options.ticketRow.id) === String(result.ticket.id)) {
      applyTicketSnapshot(options.ticketRow, result.ticket);
    }
    const listTicket = options.tickets?.find(
      (t) => String(t?.id) === String(result.ticket!.id)
    );
    if (listTicket) {
      applyTicketSnapshot(listTicket, result.ticket);
    }
  }

  const servicePatch = result.services?.[0];
  if (servicePatch && options.serviceRow) {
    applyServiceSnapshot(options.serviceRow, servicePatch);
  } else if (options.serviceRow && result.serviceTotal?.amount != null) {
    options.serviceRow.total = result.serviceTotal.amount;
    options.serviceRow.editOperation = true;
  }
}

/** Suma delta al costo USD mostrado del itinerario (sin refetch). */
export function applyItineraryCostDeltaDollars(
  itinerary:
    | {
        newTotalCostoDolares?: number | null;
        totalCostoDolares?: number | null;
      }
    | null
    | undefined,
  delta: number | null | undefined
): void {
  if (!itinerary || delta == null || !Number.isFinite(delta)) {
    return;
  }
  const current =
    itinerary.newTotalCostoDolares ?? itinerary.totalCostoDolares ?? 0;
  itinerary.newTotalCostoDolares = Number((Number(current) + delta).toFixed(2));
}
